import React from "react";
import TourneyDetailsOverviewCard from "./TourneyDetailsOverviewCard";
import TourneyDetailsOverviewDetailCard from "./TourneyDetailsOverviewDetailCard";
import { TOURNEY_STATUS_LIVE, TOURNEY_TYPES } from "@/Poker/data/Constants";
import EventCard from "./EventCard";

function TourneyDetailsOverview({ selectedTourneyDetails }) {
  return (
    <div className="">
      {/* tournamentType: "Flight_Child" || "Flight_Parent" */}
      {(selectedTourneyDetails?.tournamentType == TOURNEY_TYPES.FLIGHT_CHILD ||
        selectedTourneyDetails?.tournamentType ==
          TOURNEY_TYPES.FLIGHT_PARENT) && (
        <div className="mb-3">
          <EventCard
            isFlightParentTourney={
              selectedTourneyDetails?.isFlightParentTourney || ""
            }
            parentTourneyName={selectedTourneyDetails?.parentTourneyName || ""}
            parentTourney={selectedTourneyDetails?.parentTourney || ""}
          />
        </div>
      )}

      <TourneyDetailsOverviewCard
        selectedTourneyDetails={selectedTourneyDetails}
      />
      {selectedTourneyDetails?.tourneyStatus == TOURNEY_STATUS_LIVE && (
        <TourneyDetailsOverviewDetailCard
          isSummary
          selectedTourneyDetails={selectedTourneyDetails}
        />
      )}
      <TourneyDetailsOverviewDetailCard
        selectedTourneyDetails={selectedTourneyDetails}
      />
    </div>
  );
}

export default TourneyDetailsOverview;

const TourneyDetailsOverviewDetailCardData = [
  { title: "STARTING STACK", value: "2,500 chips" },
  { title: "LATE REGISTRATION", value: "Upto 100 minutes\nTill 8th level" },
  { title: "RE-ENTRY", value: "Unlimited\nTill Xth Level" },
  { title: "RE-BUY", value: "Upto 10 rebuys\nTill Xth Level" },
  { title: "BOUNTY TYPE", value: "Standard\n₹200 / Player" },
  { title: "DEAL MAKING", value: "Allowed" },
  { title: "TIME BANK", value: "XX seconds" },
  { title: "DISCONNECTION TIME", value: "XX seconds" },
  { title: "ADDON", value: "Allowed" },
  { title: "BREAK", value: "Available\nEvery 25th minute, past the hour" },
  { title: "PLAYERS PER TABLE", value: "8-Max" },
];
